import { render, staticRenderFns } from "./CardsSentTrend.vue?vue&type=template&id=8f853c46"
import script from "./CardsSentTrend.vue?vue&type=script&lang=js"
export * from "./CardsSentTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports